var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 62,
    viewBox: "0 0 92 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4995 10.6665V54.5519C47.4995 57.5496 49.313 60.251 52.068 61.4013C54.8405 62.5516 58.0315 61.9068 60.1414 59.7979L89.453 30.5003C90.848 29.106 91.6152 27.2237 91.6152 25.2543C91.6152 23.2848 90.8305 21.4025 89.453 20.0083L69.4527 0.0175781C64.3088 6.48361 56.3924 10.6316 47.4995 10.6491V10.6665Z",
    fill: "url(#paint0_linear_1953_16582)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5179 10.6489V54.5343C44.5179 57.532 42.7044 60.2335 39.9494 61.3838C37.1769 62.534 33.9859 61.8892 31.876 59.7803L2.54696 30.4827C1.16943 29.0884 0.384766 27.2061 0.384766 25.2367C0.384766 23.2673 1.16943 21.385 2.54696 19.9907L22.5647 0C27.7086 6.46603 35.625 10.6141 44.5179 10.6315V10.6489Z",
    fill: "#225CA6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1953_16582",
    x1: 63.6136,
    y1: -5.61406,
    x2: 63.6136,
    y2: 127.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/Sucess.e837261d8264e811f8f5f92113171dad.svg";
export { ForwardRef as ReactComponent };